import * as React from 'react'
import MUIFormHelperText from '@mui/material/FormHelperText'

const FormHelperText = (props) => <MUIFormHelperText {...props} />

export default FormHelperText
